import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  bg:'#0A0E1A',surface:'#111827',card:'#0D1526',
  accent:'#00D4AA',gold:'#F59E0B',border:'#1e2d45',
  text:'#E8EDF5',muted:'#6b7fa3',navy:'#003366',
};

export default function LandingPage() {
  const [stats, setStats] = useState({ users: 131, countries: 4, conversations: 0, messages: 0 });
  useEffect(() => {
    fetch('/api/public/stats')
      .then(r => r.json())
      .then(d => { if (d.success) setStats(d.data); })
      .catch(() => {});
  }, []);

  const navigate = useNavigate();
  return (
    <div style={{fontFamily:"sans-serif",background:C.bg,color:C.text,position:'fixed',inset:0,overflowY:'auto',overflowX:'hidden'}}>

      {/* HEADER */}
      <div style={{position:'sticky',top:0,zIndex:100,background:C.bg,borderBottom:`1px solid ${C.border}`,padding:'14px 20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div style={{display:'flex',alignItems:'baseline'}}>
          <span style={{fontSize:22,fontWeight:700,color:C.accent,letterSpacing:-1}}>PAY</span>
          <span style={{fontSize:22,fontWeight:700,color:C.text,letterSpacing:-1,position:'relative',left:-6}}>CHAT</span>
          <span style={{fontSize:10,color:C.muted,marginLeft:4}}>by ZENVOI</span>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={()=>navigate('/login')} style={{background:'transparent',border:`1px solid ${C.border}`,borderRadius:10,padding:'8px 16px',color:C.muted,fontSize:13,cursor:'pointer'}}>Connexion</button>
          <button onClick={()=>navigate('/register')} style={{background:C.accent,border:'none',borderRadius:10,padding:'8px 16px',color:'#000',fontSize:13,fontWeight:700,cursor:'pointer'}}>Rejoindre</button>
        </div>
      </div>

      {/* HERO */}
      <div style={{padding:'60px 24px 40px',textAlign:'center'}}>
        <div style={{display:'inline-block',background:C.accent+'22',border:`1px solid ${C.accent}44`,borderRadius:20,padding:'4px 16px',fontSize:12,color:C.accent,marginBottom:20}}>
          ✅ Déjà disponible sur zenvoi.app
        </div>
        <h1 style={{fontSize:32,fontWeight:700,lineHeight:1.3,marginBottom:16}}>
          La messagerie qui<br/><span style={{color:C.accent}}>comprend l’Afrique</span>
        </h1>
        <p style={{fontSize:15,color:C.muted,lineHeight:1.7,marginBottom:32,maxWidth:340,margin:'0 auto 32px'}}>
          Chattez en toute sécurité avec vos proches au Cameroun et dans le monde. Les paiements mobiles intégrés arrivent bientôt.
        </p>
        <div style={{display:'flex',gap:12,justifyContent:'center',flexWrap:'wrap',marginBottom:48}}>
          <button onClick={()=>navigate('/register')} style={{background:C.accent,border:'none',borderRadius:12,padding:'14px 28px',color:'#000',fontSize:15,fontWeight:700,cursor:'pointer'}}>
            Créer un compte gratuit
          </button>
          <button onClick={()=>navigate('/login')} style={{background:'transparent',border:`1px solid ${C.border}`,borderRadius:12,padding:'14px 20px',color:C.text,fontSize:15,cursor:'pointer'}}>
            Se connecter
          </button>
        </div>
        {/* PHONE MOCKUP */}
        <div style={{width:200,margin:'0 auto 20px',background:'#111827',borderRadius:28,padding:'14px 10px',border:`1px solid ${C.border}`}}>
          <div style={{background:C.card,borderRadius:18,overflow:'hidden'}}>
            <div style={{background:C.navy,padding:'10px 12px',display:'flex',alignItems:'center',gap:8}}>
              <div style={{width:30,height:30,background:C.accent,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'#000'}}>D</div>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:C.text}}>Davy</div>
                <div style={{fontSize:10,color:C.accent}}>En ligne</div>
              </div>
            </div>
            <div style={{padding:'8px 6px 12px'}}>
              <div style={{background:C.accent+'22',borderRadius:'10px 10px 2px 10px',margin:'4px 4px 4px 30px',padding:'6px 10px',fontSize:11,color:C.text}}>Tu es dispo ce soir ?</div>
              <div style={{background:C.border,borderRadius:'10px 10px 10px 2px',margin:'4px 30px 4px 4px',padding:'6px 10px',fontSize:11,color:C.text}}>Oui ! À 20h 👍</div>
              <div style={{background:C.accent+'22',borderRadius:'10px 10px 2px 10px',margin:'4px 4px 4px 30px',padding:'6px 10px',fontSize:11,color:C.text}}>Super, j’envoie au groupe</div>
              <div style={{background:C.border,borderRadius:'10px 10px 10px 2px',margin:'4px 30px 4px 4px',padding:'6px 10px',fontSize:10,color:C.muted}}>📍 Localisation partagée</div>
            </div>
          </div>
        </div>
        {/* NAVIGATION RAPIDE */}
        <div style={{display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap',marginTop:16}}>
          {[['À propos','/a-propos'],['Business','/business'],['Investisseurs','/investisseurs'],['Contact','/contact']].map(([l,h])=>(
            <button key={l} onClick={()=>navigate(h)} style={{background:'transparent',border:`1px solid ${C.border}`,borderRadius:20,padding:'6px 14px',color:C.muted,fontSize:12,cursor:'pointer'}}>{l}</button>
          ))}
        </div>
      </div>

      {/* STATS */}
      <div style={{padding:'0 20px 40px'}}>
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{fontSize:20,fontWeight:700,marginBottom:6}}>PayChat aujourd’hui</div>
          <div style={{fontSize:13,color:C.muted}}>Un produit opérationnel et en croissance</div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
          {[{num:stats.users+'',label:'Utilisateurs actifs'},{num:stats.countries+'',label:'Pays représentés'},{num:'34',label:'Fonctionnalités'},{num:'Avril 2026',label:'Date de lancement'}].map((s,i)=>(
            <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,textAlign:'center'}}>
              <div style={{fontSize:22,fontWeight:700,color:C.accent}}>{s.num}</div>
              <div style={{fontSize:11,color:C.muted,marginTop:4}}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FONCTIONNALITES */}
      <div style={{padding:'0 20px 40px'}}>
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{fontSize:20,fontWeight:700,marginBottom:6}}>Fonctionnalités</div>
          <div style={{fontSize:13,color:C.muted}}>Ce qui est disponible — et ce qui arrive</div>
        </div>
        {[
          {icon:'💬',title:'Messagerie sécurisée',desc:'Messages, photos, vidéos, vocaux. Chiffrement de bout en bout.',ok:true},
          {icon:'📞',title:'Appels audio & vidéo',desc:'Appels individuels et de groupe WebRTC. Qualité HD.',ok:true},
          {icon:'👥',title:'Groupes & Canaux',desc:'Groupes, sondages, messages éphémères, diffusion.',ok:true},
          {icon:'🔐',title:'Sécurité avancée',desc:'2FA, reconnaissance faciale, PIN de sécurité.',ok:true},
        ].map((f,i)=>(
          <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:'14px 16px',marginBottom:10,display:'flex',gap:14,alignItems:'flex-start'}}>
            <div style={{fontSize:24,flexShrink:0}}>{f.icon}</div>
            <div style={{flex:1}}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap'}}>
                <span style={{fontSize:14,fontWeight:700}}>{f.title}</span>
                <span style={{background:C.accent+'22',color:C.accent,border:`1px solid ${C.accent}44`,borderRadius:8,padding:'2px 8px',fontSize:10}}>Disponible</span>
              </div>
              <div style={{fontSize:12,color:C.muted,lineHeight:1.6}}>{f.desc}</div>
            </div>
          </div>
        ))}
        <div style={{background:'#F59E0B11',border:'1px solid #F59E0B44',borderRadius:14,padding:'14px 16px',margin:'20px 0',display:'flex',gap:12}}>
          <div style={{fontSize:22,flexShrink:0}}>⏳</div>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:C.gold,marginBottom:4}}>Paiements mobiles — En cours d’intégration</div>
            <div style={{fontSize:12,color:C.muted,lineHeight:1.7}}>Les fonctionnalités de paiement sont développées et en attente de l’agrément réglementaire COBAC/BEAC. Elles seront activées progressivement en 2026–2027.</div>
          </div>
        </div>
        {[
          {icon:'💰',title:'Wallet FCFA',desc:'Portefeuille électronique intégré à la messagerie.'},
          {icon:'🎙️',title:'Paiement vocal IA',desc:'Envoie 5000 FCFA à Davy — unique en Afrique francophone.'},
          {icon:'🤝',title:'Tontine / Njangi digital',desc:'Gérez votre tontine en ligne — cotisations automatiques.'},
          {icon:'🌍',title:'Transferts internationaux',desc:'Envois d’argent vers l’Afrique et la diaspora.'},
        ].map((f,i)=>(
          <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:'14px 16px',marginBottom:10,display:'flex',gap:14,alignItems:'flex-start',opacity:0.8}}>
            <div style={{fontSize:24,flexShrink:0}}>{f.icon}</div>
            <div style={{flex:1}}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap'}}>
                <span style={{fontSize:14,fontWeight:700}}>{f.title}</span>
                <span style={{background:'#F59E0B22',color:C.gold,border:'1px solid #F59E0B44',borderRadius:8,padding:'2px 8px',fontSize:10}}>Bientôt</span>
              </div>
              <div style={{fontSize:12,color:C.muted,lineHeight:1.6}}>{f.desc}</div>
            </div>
          </div>
        ))}
      </div>

      {/* TEMOIGNAGES */}
      <div style={{background:C.card,padding:'40px 20px',borderTop:`1px solid ${C.border}`,borderBottom:`1px solid ${C.border}`}}>
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{fontSize:20,fontWeight:700,marginBottom:6}}>Ce que disent nos utilisateurs</div>
          <div style={{fontSize:13,color:C.muted}}>Ils testent PayChat depuis avril 2026</div>
        </div>
        {[
          {text:"La messagerie est fluide et sécurisée. J’adore pouvoir appeler en vidéo depuis la même app !",name:'Solange A.',loc:'Douala, Cameroun',init:'S',color:'#2E7D6B'},
          {text:"Enfin une app camerounaise sérieuse. L’interface est propre, les appels de groupe fonctionnent très bien !",name:'Conrad M.',loc:'Douala, Cameroun',init:'C',color:'#003366'},
          {text:"Je vis en France et je reste connecté avec ma famille au Cameroun. PayChat est simple et rapide !",name:'Bertrand T.',loc:'Paris, France',init:'B',color:'#2E7D6B'},
        ].map((t,i)=>(
          <div key={i} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:12}}>
            <div style={{fontSize:13,color:C.text,lineHeight:1.7,marginBottom:12,fontStyle:'italic'}}>"{t.text}"</div>
            <div style={{display:'flex',alignItems:'center',gap:10}}>
              <div style={{width:32,height:32,borderRadius:'50%',background:t.color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'#fff'}}>{t.init}</div>
              <div>
                <div style={{fontSize:13,fontWeight:700}}>{t.name}</div>
                <div style={{fontSize:11,color:C.muted}}>{t.loc}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* INVESTISSEURS */}
      <div style={{background:C.navy,padding:'40px 20px',textAlign:'center'}}>
        <div style={{fontSize:20,fontWeight:700,color:C.text,marginBottom:8}}>Investisseurs & Partenaires</div>
        <div style={{fontSize:13,color:'#8899bb',marginBottom:24,lineHeight:1.7}}>ZENVOI SARL lève 150 millions FCFA en phase Seed pour accélérer le déploiement et obtenir l’agrément COBAC/BEAC.</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:24}}>
          {[{num:'3M+',label:'Utilisateurs cibles 2031'},{num:'10',label:'Pays cibles 2031'},{num:'20 Mds FCFA',label:'Valorisation projetée'},{num:'2029',label:'Rentabilité projetée'}].map((s,i)=>(
            <div key={i} style={{background:'#ffffff11',border:'1px solid #ffffff22',borderRadius:12,padding:14,textAlign:'center'}}>
              <div style={{fontSize:16,fontWeight:700,color:C.accent}}>{s.num}</div>
              <div style={{fontSize:10,color:'#8899bb',marginTop:4}}>{s.label}</div>
            </div>
          ))}
        </div>
        <button onClick={()=>navigate('/investisseurs')} style={{background:C.accent,border:'none',borderRadius:12,padding:'14px 28px',color:'#000',fontSize:15,fontWeight:700,cursor:'pointer'}}>
          En savoir plus
        </button>
      </div>

      {/* FOOTER */}
      <div style={{background:'#060912',padding:'24px 20px',textAlign:'center'}}>
        <div style={{marginBottom:6}}>
          <span style={{fontSize:18,fontWeight:700,color:C.accent}}>PAY</span>
          <span style={{fontSize:18,fontWeight:700,color:C.text,position:'relative',left:-5}}>CHAT</span>
          <span style={{fontSize:11,color:C.muted,marginLeft:4}}>by ZENVOI SARL</span>
        </div>
        <div style={{fontSize:11,color:C.muted,marginBottom:16}}>BP 12619 — Douala, Cameroun · GilbertOdzo@zenvoi.co · +237 697 008 362</div>
        <div style={{display:'flex',gap:16,justifyContent:'center',flexWrap:'wrap',marginBottom:16}}>
          {[['Confidentialité','/privacy'],['CGU','/privacy'],['PayChat Business','/business'],['À propos','/a-propos'],['Investisseurs','/investisseurs']].map(([l,h])=>(
            <button key={l} onClick={()=>navigate(h)} style={{background:'none',border:'none',fontSize:12,color:C.muted,cursor:'pointer'}}>{l}</button>
          ))}
        </div>
        <div style={{fontSize:11,color:'#2a3a5a'}}>© 2026 ZENVOI SARL — Tous droits réservés</div>
      </div>
    </div>
  );
}
